import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-new-tab.tsx
/**
* icon.24.new.tab
*
* Keywords: external, arrow, outward, square, diagonal, share, link, open
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTkuNSA2YS41LjUgMCAwIDEgMCAxaC0yYS41LjUgMCAwIDAtLjUuNXY5YS41LjUgMCAwIDAgLjUuNWg5YS41LjUgMCAwIDAgLjUtLjV2LTJhLjUuNSAwIDAgMSAxIDB2MmExLjUgMS41IDAgMCAxLTEuNSAxLjVoLTlBMS41IDEuNSAwIDAgMSA2IDE2LjV2LTlBMS41IDEuNSAwIDAgMSA3LjUgNnptOCAwYS41LjUgMCAwIDEgLjUuNXY1YS41LjUgMCAwIDEtMSAwVjcuNzA3bC00LjE0NiA0LjE0N2EuNS41IDAgMSAxLS43MDctLjcwN0wxNi4yOTMgN0gxMi41YS41LjUgMCAwIDEgMC0xeiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1678
*/
const Icon24NewTab = memo(function Icon24NewTab(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M9.5 6a.5.5 0 0 1 0 1h-2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6zm8 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V7.707l-4.146 4.147a.5.5 0 1 1-.707-.707L16.293 7H12.5a.5.5 0 0 1 0-1z"
		})
	});
});
//#endregion
export { Icon24NewTab };

//# sourceMappingURL=icon-24-new-tab.js.map